const restEndpoints = {
  removebg: '/api/removebg',
  tiff: '/api/tiff',
  extractWatermark: '/api/extractWatermark',
  // uploadImage: '/api/uploadImage',
  excelDownload: '/api/export/products',
  icaExcelDownload: '/api/export/ica-products',
  woltExcelDownload: '/api/export/wolt-products',
  apoteaExcelDownload: '/api/export/apotea-products',
  approvedProductsDownload: '/api/export/productsWithImages',
  superuserProductsDownload: '/api/export/superuserProductsWithImages',
  apotea: '/api/export/apotea',
  apoteaJson: '/api/export/apotea-json',
  ica: '/api/export/ica',
  wolt: '/api/export/wolt',
  coop: '/api/export/coop',
  aiProduct: '/api/ai/product',
  aiImage: '/api/ai/image',
  aiImageBulk: '/api/ai/image-bulk',
  aiImageImprove: '/api/ai/image-improve',
  // aiImageTranscriber: '/api/ai/image-transcriber',
  aiCategory: '/api/ai/category',
  aiOrgCategory: '/api/ai/org-category',
  aiDimensions: '/api/ai/dimensions',
  aiProductReview: '/api/ai/product-review',
  productAssistant: '/api/product-assistant',
  insights: '/api/insights',
  surveyKnowProductOnline: '/api/survey/know-product-online',
};

// TODO
// export const restEndpoints = {
//   removebg: getBackendHost('/api/removebg') || '/api/removebg',
//   tiff: getBackendHost('/api/tiff') || '/api/tiff',
//   uploadImage: getBackendHost('/api/uploadImage') || '/api/uploadImage',
//   excelDownload: getBackendHost('/api/export/products') || '/api/export/products',
//   approvedProductsDownload: getBackendHost('/api/export/productsWithImages') || '/api/export/productsWithImages',
//   superuserProductsDownload: getBackendHost('/api/export/superuserProductsWithImages') || '/api/export/superuserProductsWithImages',
// };

export default restEndpoints;
